'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isObject2 = require('lodash/isObject');

var _isObject3 = _interopRequireDefault(_isObject2);

var _defaults2 = require('lodash/defaults');

var _defaults3 = _interopRequireDefault(_defaults2);

var _isFunction2 = require('lodash/isFunction');

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _reduce2 = require('lodash/reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

exports.default = transform;

var _transforms = require('./transforms');

var _transforms2 = _interopRequireDefault(_transforms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transform(props, method) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (!(0, _isArray3.default)(method)) {
        method = [method];
    }

    return (0, _reduce3.default)(method, function (props, method) {
        if ((0, _isString3.default)(method)) {
            if ((0, _isFunction3.default)(_transforms2.default[method])) {
                return (0, _defaults3.default)(_transforms2.default[method](props, options), props);
            } else {
                return props;
            }
        } else if ((0, _isFunction3.default)(method)) {
            return (0, _defaults3.default)(method(props, options), props);
        } else if ((0, _isObject3.default)(method)) {
            return transform(props, method.method, method.options);
        } else {
            return props;
        }
    }, props);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rumble-charts/lib/helpers/transform.js
// module id = 724
// module chunks = 0